import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useConfig } from "../../contexts/config-context.js";
import { DatePickerWUT } from "../date-picker/date-picker-wut.js";
import { classes } from "./date-field-wut.st.css";
import { Fieldset } from "../fieldset/fieldset.js";
function DateFieldWUT({
  onBlur,
  onChange,
  onFocus,
  inputId,
  ariaLabelledBy,
  value,
  id,
  disabled,
  errors,
  hidePlaceholder,
  showDateLabels,
  required,
  ariaDescribedBy
}) {
  const { isMobile } = useConfig();
  return /* @__PURE__ */ jsx(
    Fieldset,
    {
      id: inputId,
      onFocus,
      onBlur,
      ariaLabelledBy,
      className: classNames(classes.fields, { [classes.mobile]: isMobile }),
      ariaDescribedBy,
      required,
      children: /* @__PURE__ */ jsx(
        DatePickerWUT,
        {
          inputId,
          disabled,
          errors,
          hidePlaceholder,
          showDateLabels,
          required,
          id,
          onChange,
          value
        }
      )
    }
  );
}
export {
  DateFieldWUT
};
//# sourceMappingURL=date-field-wut.js.map
